import * as Yup from "yup";

// Basic email pattern that ensures a domain suffix (e.g., example.com)
const EMAIL_WITH_DOMAIN_REGEX = /^[^\s@]+@[^\s@]+\.[A-Za-z]{2,}$/;

Yup.addMethod(Yup.string, "emailWithDomain", function(message = "Must be a valid email address") {
    return this.test("email-with-domain", message, (value) => {
        if (!value) {
            // Defer empties to other validators like .required()
            return true;
        }
        return EMAIL_WITH_DOMAIN_REGEX.test(value);
    });
});


